import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AUTH_PATHS } from '../auth';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-change-password-incorrect',
  templateUrl: './change-password-incorrect.component.html',
  styleUrls: ['./change-password-incorrect.component.scss'],
  standalone: false,
})
export class ChangePasswordIncorrectComponent implements OnInit {
  public AUTH_PATHS = AUTH_PATHS;
  public recAccessIncorrectBreadcrumbs: Breadcrumb[] = [{ text: 'Восстановление доступа', url: null }];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.recAccessIncorrectBreadcrumbs);
  }
}
